<div class="overlay" *ngIf="speaker.isLoading">
    <div class="center">
        <mat-progress-spinner mode="indeterminate">
        </mat-progress-spinner>
    </div>
</div>

<div class="report-actions">
    <button class="btnExportExcel" mat-flat-button color="primary" (click)="exportToExcel()" [disabled]="isExporting">
        <mat-icon *ngIf="!isExporting">download</mat-icon>
        <mat-spinner *ngIf="isExporting" diameter="20" class="export-spinner"></mat-spinner>
        {{ isExporting ? 'Exporting...' : 'Export to Excel' }}
    </button>

    <mat-form-field appearance="outline" class="report-search-field">
        <mat-label>Search</mat-label>
        <input matInput type="text" (keyup)="doFilter($event)">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
</div>
<div *ngIf="showOpeningBalance" class="opening-balance-row">
    <h3>Opening Balance : {{openingBalance}}</h3>
</div>
<div class="mat-table-container">
    <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z2">

        <ng-container class="mat-table-row" [matColumnDef]="column" *ngFor="let column of displayColumns; let i = index;">
            <th class="font-weight-bold" mat-header-cell mat-sort-header *matHeaderCellDef> {{displayHeaders[i]}} </th>
            <td mat-cell *matCellDef="let obj"> {{obj[column]}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
    </table>
</div>

<mat-paginator #paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]" aria-label="Select page">
</mat-paginator>